var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('Bullet',{attrs:{"title":_vm.gdprInfo.title,"status":_vm.gdprInfo.status}}),_vm._v(" "),(_vm.legend)?_c('span',[_vm._v(_vm._s(_vm.gdprInfo.name))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01b71428","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Parts/ConsentBullet.vue
// module id = null
// module chunks = 